import {css} from 'styled-components';
import {theme} from "@/components/features/theme/theme"; // Import Style sheet


    export const globalStyleForm = css`

        .form-error{
            position: absolute;
            color: #dc004e !important;
            bottom: -26px;
            font-size: 10px;
            letter-spacing: 0;
        }
        
        .form-group{
            position:   relative;
            .error-message{
                position: absolute;
                color: #dc004e !important;
            }
        }
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
            
        }

        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        textarea:-webkit-autofill,
        textarea:-webkit-autofill:hover,
        textarea:-webkit-autofill:focus,
        select:-webkit-autofill,
        select:-webkit-autofill:hover,
        select:-webkit-autofill:focus {
            border: 1px solid ${theme.colors.white});
            background: transparent;
            -webkit-text-fill-color: ${theme.colors.text};
            -webkit-box-shadow: 0 0 0 1000px ${theme.colors.white} inset;
            transition: background-color 5000s ease-in-out 0s;
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */

        input[type=number] {
            -moz-appearance: textfield;
        }


        .btn:focus, button:focus, button:active:focus, .btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {
            outline: none;
            box-shadow: none;
        }

        button, button:active, button:focus, button:focus-visible {
            outline: none !important;
            box-shadow: none !important;
        }


        .has-error .find-retainer-filter__control {
            border-color: ${theme.colors.red} !important;
        }

        //===================react select ===================

        .css-yk16xz-control, .css-1pahdxg-control {
            height: 50px;
            border-radius: 0 !important;
            padding-left: 5px;
            font-size: 16px;
            outline: none !important;
            border-color: ${theme.colors.black} !important;
            box-shadow: none !important;

            .css-1wa3eu0-placeholder {
                font-weight: 300;
                line-height: 21px;
                color: rgba(0, 0, 0, 0.5);
                outline: none;
            }

            .css-1okebmr-indicatorSeparator {
                display: none;
            }

            .css-tlfecz-indicatorContainer, .css-1gtu0rj-indicatorContainer {
                margin-right: 10px;
            }
        }

        .css-nmuc1a-menu {
            z-index: 5 !important;
        }

        .css-2613qy-menu {
            border-radius: 0 !important;
            margin-top: 0 !important;
        }

        .valid {
            color: ${theme.colors.hover};
            position: absolute;
            font-size: 12px;
            top: 44px;
        }

        .form-control.has-error {
            border-color: ${theme.colors.red} !important;
        }
        .valid {
            color: ${theme.colors.hover};
            position: absolute;
            font-size: 12px;
            top: 44px;
        }
        .form-control:disabled {
            background-color: transparent;
        }
        .has-error .find-retainer-filter__control {
            border-color: ${theme.colors.red} !important;
        }

        button, button:active, button:focus, button:focus-visible {
            outline: none !important;
            box-shadow: none !important;
        }

        //===================form-control====================
        button, input, optgroup, select, textarea {
            font-family: inherit;
            font-size: 100%;
            line-height: 1.15;
            margin: 0px;
        }
        input:not([type="image" i], [type="range" i], [type="checkbox" i], [type="radio" i]) {
            overflow-clip-margin: 0px !important;
            overflow: clip !important;
        }
        form {
            display: flex;
            position: relative;
            flex-flow: wrap;
            gap: 15px;
            justify-content: space-between;

        
            div {
                position: relative;
            }
            .form-item {
                margin-bottom: 50px;
            }
           
            .form-group{
                position: relative;
                &.value-added{
                    position: relative;
                    &:after{
                        content: '';
                        position: absolute;
                        top: 0;
                        right: 0;
                        background-image: url(/images/static/lock.svg);
                        background-size: contain !important;
                        background-position: right;
                        background-repeat: no-repeat;
                        width: 18px;   /* required */
                        height: 25px;  /* required */
                        z-index: 1;
                    }
                }
                
                .error-message{
                    position: absolute;
                    bottom: 4px;
                }
                .form-control {
                    border: none;
                    border-bottom: 1px solid #4A4A4A;;
                    background-color: transparent !important;
                    padding: 0 0 10px 0;
                    outline: none;
                    box-shadow: none;
                    outline: 0;
                    border-radius: 0;
                    width: 100%;
                    position: relative;
                    z-index: 2;
                    border-image: initial;
                    border-bottom: 1px solid rgb(179, 173, 173);
                    transition: border-color 0.3s ease-in-out;
                    color: #4A4A4A;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px; /* 150% */


                    &::placeholder {
                        color:  rgba(66, 52, 40, 0.50);
                    }

                    &:focus {
                        box-shadow: none;

                        border-color: rgba(66, 52, 40, 0.50);
                    }

                    &:disabled {
                        background-color: transparent;
                    }

                    &.has-error {
                        border-color: ${theme.colors.red} !important;
                    }
                }
            }

            textarea {
                min-height: 120px !important;
                max-height: 120px !important;
            }
        }
    `;

